<template>
    <zm-dialog class="videosdk-detail-dialog" :visible.sync="visible" show-close @close="handleCancel">
        <!--header-->
        <h1 class="videosdk-detail-dialog__title">{{ planCategoryName }}</h1>
		<p class="opc-addon-config__main__plan__capacity">
			<span
			class="opc-addon-config__main__plan__capacity-recommend">
			{{ planDesc }}
			</span>
        </p>
        <div class="videosdk-detail-dialog__price">
			<p class="opc-addon-config__main__plan__price">
              <span class="opc-addon-config__main__plan__price--amount">{{ price }}</span>
              <span class="opc-addon-config__main__plan__price--unit">/ {{$t('billing.video_sdk.unit')}}<priceVATTip />
				<zm-tooltip class="opc-addon-config-row__input__number--tips" :aria-label="'unit tooltip'" placement="bottom">
					<div slot="content" v-html="$t('billing.video_sdk.plan_details.unit_tooltip')" />
					<i role="button" class="zm-icon-info-outline" @mouseover="showTooltip"/>
				</zm-tooltip>
			</span>
            </p>
        </div>
        <ul class="videosdk-detail-dialog__feature">
            <li class="videosdk-detail-dialog__feature-item">
			<h2 class="zone-detail-dialog__feature-title first-capitalize">{{ $t('billing.video_sdk.plan_details.cloud_based')}}</h2>
			<span>{{ $t('billing.video_sdk.plan_details.cloud_based_desc')}}</span></li>
			<li class="videosdk-detail-dialog__feature-item">
			<h2 class="zone-detail-dialog__feature-title first-capitalize">{{ $t('billing.video_sdk.plan_details.customizable')}}</h2>
			<span>{{ customDesc }}</span></li>
			<li class="videosdk-detail-dialog__feature-item">
			<h2 class="zone-detail-dialog__feature-title first-capitalize">{{ $t('billing.video_sdk.plan_details.hd')}}</h2>
			<span>{{ $t('billing.video_sdk.plan_details.hd_desc')}}</span></li>
			<li class="videosdk-detail-dialog__feature-item">
			<h2 class="zone-detail-dialog__feature-title first-capitalize">{{ $t('billing.video_sdk.plan_details.flexible')}}</h2>
			<span>{{ flexibleDesc }}</span></li>
        </ul>
    </zm-dialog>
</template>
<script type="text/jsx">
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import EssentialAppLearnMoreDialog from '@/components/app-bundle-learn-more-dialog.vue';
import { mapState } from 'vuex';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import { getCurrency, getCurrencySymbol } from "@/utils/currency";
import { toThousands } from '@/utils/money';
import { translation } from '@/plugins/i18n';

export default {
    name: 'PlanDetails',
    mixins: [ConfirmComponent],
    props: {
        planCategory: String,
    },
    data() {
        return {
            visible: false,
            currencySymbol: getCurrencySymbol(getCurrency()),
            essentialAppLearnMoreDialogService: new ServiceConfirm(EssentialAppLearnMoreDialog, this.$store),
			planDesc: translation('billing.video_sdk.free_min',[toThousands(10000)]),
			customDesc: translation ('billing.video_sdk.plan_details.customizable_desc',[toThousands(1000)]),
        };
    },
    computed: {
        ...mapState({
            planMapFlat: (state) => state.ShoppingCart.planMapFlat,
        }),
        price() {
			let targetPlan = this.planMapFlat.find(plan => plan.category === this.planCategory);
            if (targetPlan) {
                return targetPlan.excessPrice;
            }
			return ''
        },
        planCategoryName() {
            return this.$t("billing.planform.title.video_sdk") +  ' ' + this.$t("billing.pay_you_go");
        },
		flexibleDesc(){
			return translation('billing.video_sdk.plan_details.flexible_desc',[toThousands(10000),this.price])
		},
        trackingPlanName(){
            return 'video sdk pay as you go'
        }
    },
    methods:{
        handleCancel() {
            this.$tracking.buyInteraction('product details', `${this.trackingPlanName} - close`);
        },
        showTooltip() {
            this.$tracking.buyInteraction('product details', `${this.trackingPlanName} - tooltip`);
        },
    }
}
</script>
<style lang="scss">
@import '@/styles/_variables.scss';

.videosdk-detail-dialog {

	.opc-addon-config__main__plan__capacity{
		margin: 10px 0;
		.opc-addon-config__main__plan__capacity-recommend{
			margin-left: 0;
		}
	}
    .zm-dialog {
        min-width: 522px;
        padding: 70px 60px;
        width: fit-content;
    }

    &__title {
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 150%;
        color: #00053D;
    }

    &__price {
        width: 100%;
        display: flex;
        flex-direction: row;
        margin-bottom: 12px;

		.zm-icon-info-outline {
			color: #0B5CFF;
			font-size: 14px;
		}

        &-item {
            flex: 1;
            padding-right: 24px;
            padding-left: 0;
            display: flex;
            align-items: flex-start;

            .price__currency {
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 36px;
                color: #00053D;
                margin-right: 2px;
            }

            .price__int {
                font-family: $happy-display;
                font-style: normal;
                font-weight: 400;
                font-size: 32px;
                line-height: 48px;
                color: #00053D;
                margin-right: 2px;
            }

            .price__decimal {
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 36px;
                color: #00053D;
                margin-right: 2px;
            }

            .price__unit {
                font-style: normal;
                font-weight: 450;
                font-size: 16px;
                line-height: 38px;
                color: #00053D;
                align-self: flex-end;
            }

            &+& {
                padding-right: 0;
                padding-left: 24px;
                border-left: 2px solid #B8B8C4;
            }
        }

    }

    &__feature {
        &-title {
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 150%;
            color: #00053D;
        }

        &-item {
            position: relative;
            padding-left: 20px;
            margin-bottom: 16px;

            &::before {
                position: absolute;
                top: 0;
                left: 0;
                content: "";
                background-image: url('../../../assets/Vector.svg');
                background-repeat: no-repeat;
                background-size: cover;
                width: 16px;
                height: 21px;
                font-size: 20px;
                font-weight: 700;
            }
        }

        span {
            font-style: normal;
            font-weight: 450;
            font-size: 12px;
            line-height: 18px;
            color: #666487;
        }
    }
}</style>
